import { render } from "./Result.vue?vue&type=template&id=e938327a&scoped=true"
import script from "./Result.vue?vue&type=script&lang=js"
export * from "./Result.vue?vue&type=script&lang=js"

import "./Result.vue?vue&type=style&index=0&id=e938327a&scoped=true&lang=css"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e938327a"]])

export default __exports__